//tc.js
module.exports={
  nav: {
		// 導航
	  index: '首頁',
		/*********************/
	  aboutFortune: '關於富陽',
	  fortuneIntro: '富陽簡介',
	  develop: '發展歷程',
	  manageTeam: '管理團隊',
	  developVision: '發展願景',
	  /*********************/
	  enterprise: '企業管治',
	  board: '董事會',
	  audit: '審核委員會',
	  payment: '薪酬委員會',
	  nominate: '提名委員會',
	  executiveCommittee: '執行委員會',
	  /*********************/
	  BusinessAreas: '業務領域',
	  GroupArchitecture: '業務範圍',
	  classicCase: '經典案例',
		/*********************/
	  domesticCase: '國內個案',
	  ClassicCases: '代表個案',
	  /*********************/
	  overseasCase: '海外置業',
	  BeltRoad: '一帶一路',
	  Cambodia: '柬埔寨',
	  IntermediaryShop: '中介店',
	  /*********************/
	  investor: '投資者關係',
	  financeReporting: '財務報告',
	  GroupAnnouncement: '集團公告',
	  /*********************/
	  officeEntrance: '辦公入口',
	  OAofficeSystem: 'OA辦公系統',
	  enterpriseEmail: '企業郵箱登錄',
	  salesSystem:'銷售系統',
	  /*********************/
	  job:'招贤纳士',
	  relation: '聯繫我們',
	  /*********************/
	  languageSwitch: '語言',
	  zhLanguage: '簡體',
	  tcLanguage: '繁體',
	  enLanguage: 'EN',
  },
	//首頁
  index:{
  	aboutFortuneSun:'關於富陽',
  	aboutFSIntroduce:'自1997年創立以來，我們致力成為本土化、國際化的房地產專業營銷公司，我們延攬且培養了眾多來自國內外的房地產專業人才，運用了現代化，科技化的整合管理工具，幫助我們進行內部流程的有效控管，並實踐了每一個項目的高效營銷，確保每一個項目都能在複雜多變的市場競爭中有效執行，贏得漂亮的成績。',
  	clickEnter:'點擊進入&gt;',
  	FSChina:'富陽（中國）控股有限公司',
  	FSChinaIntroduce:'本集團成立於1997年，總部位於上海，2006年在香港聯合交易所主板上市（編號00352），自成立以來，不斷完善房地產管理服務內容，提供一站式方案，滿足客戶的需要。近年來加速海外拓展，持續不斷地為海內外華人，提供具有價值及內涵的國際化房地產咨詢服務。'
  },
  // 關於富陽
  about:{
  	FSIntroduce:'二十餘年來積累的行業專業性，敏銳的市場判斷力和資本運營能力，見證了全球經濟飆漲，亞洲財富迅速擴張，將迅速整合集團資源，把握全球財富機遇，與新組建的歐美及東盟海外中高端房地產服務體系，構建起以海內外資產配置的產品端和客戶端，並依託集團現代化的信息技術，提升整個房地產產業鏈的價值服務，持續為廣大的中高端客戶及高淨值客戶，提供更多元化及一站式的全球資產配置服務體系。',
  	developmentImgIntroduce01:'熱烈祝賀富陽（中國）控股於香港聯交所主板上市',
  	developmentImgIntroduce02:'上海總部的同仁們慶祝集團在香港上市以HK0352創意合照',
  	developmentImgIntroduce03:'江陳鋒主席在香港聯交所與重要貴賓見證歷史時刻並合影',
  	developmentImgIntroduce04:'首開先例的黃浦江郵輪豪華晚宴，達成企業和項目品牌的圓滿聯動',
  	developmentImgIntroduce05:'來自江浙滬港台的高端客戶，為富陽（中國）控股成功打造優質品牌形象',
  	developmentImgIntroduce06:'張秀華執行董事為財富海景發展論壇致詞',
  	developmentImgIntroduce07:'富陽（中國）控股同仁們送愛心到汶川災區，慷慨解囊',
  	developmentImgIntroduce08:'張秀華執行董事帶隊走訪肥東小學，讓愛心滿人間',
  	developmentImgIntroduce09:'2016年9月12日，富陽(中國)控股主席江陳鋒先生與Creed Group總裁Takashi Eguchi先生簽署合作協議，開啓跨國戰略共贏的首善之作',
  	developmentImgIntroduce10:'2016年11月19日，富陽（中國）控股主席江陳鋒，日本creed集團董事長宗吉敏彥等各界領導與嘉賓共同為富陽海外置業展廳揭幕',
  	developmentImgIntroduce11:'2016年11月19日，海外盛世，繽紛啓幕——富陽海外置業上海展廳耀世公開',
  	developmentImgIntroduce12:'2016年12月17日，富陽房地產公司及中介門店於柬埔寨首都金邊正式開業',
  	developmentImgIntroduce13:'2017年12月14日，冬日地鐵輕出行，富陽（中國）控股公益暖人心',
  	developmentVision:'嚴謹，誠信，專業是我們的服務理念，我們的服務涵蓋房地產投資管理、房地產金融業務、房地產銷售業務、房地產信息業務四大價值服務體系，以上海為運營總部，覆蓋20多個省市，近100個城市，海外持續拓展亞洲、歐洲、美洲和東盟十國，以行業先鋒之姿，提供開發商、客戶們在風險和成本上的安全管理，並實現客戶們在全球資產投資配置上的優化。'
  },
  // 管理團隊
  manageTeam:{
  	director:'董事',
  	jiangchenfeng:'江陳鋒先生，',
  	jcfIntroduce:'主席兼執行董事及本集團創辦人之一。江先生於一九八九年六月畢業於台灣逢甲大學，取得企管系學士學位，並開始從事房地產評估及市場研究。於一九九五年至一九九六年間，江先生為沿海綠色家園有限公司（股份代號：01124）（其股份在香港聯合交易所有限公司（「聯交所」）主板上市）的研究員，專注於研究中國市場。江先生於一九九七年四月共同創辦本集團，並自此獲委任為上海富陽物業咨詢有限公司（「上海富陽」）的董事。此外，亦為本公司其他附屬公司的董事。',
	  wangjia:'王佳女士，',
  	wjIntroduce:'目前為本公司全資附屬公司上海富陽物業諮詢有限公司（「上海富陽」）的董事，負責監督所有發展項目及管理本集團日常營運。王女士於一九九七年四月加入本集團，曾於上海富陽銷售部門擔任不同職位。王女士於一九九二年七月畢業於上海大學，主修機械設計製造。王女士擁有豐富的物業銷售及營銷經驗，同時亦為上海房地產經紀人證書的持有人。',
		zhangxiuhua:'張秀華女士，',
  	zxhIntroduce:'執行董事。張女士於一九八八年六月畢業於台灣逢甲大學，取得財稅系學士學位。於一九八八年，張女士加入仲慶汽車有限公司，負責估值及保險事宜。於一九九三年一月，張女士開始於衡平法律事務所工作，負責法務工作。張女士於一九九七年七月加入上海富陽，出任財務部經理，並於二零零零年一月獲委任為上海富陽高級管理層成員之一，負責財務管理。於二零零五年八月，張女士獲委任為上海富陽的董事。',
  	nonDirector:'非執行董事',
  	linqianru:'林倩如女士，',
  	lqrIntroduce:'非執行董事。林女士於一九九六年四月自美國酒店及汽車旅館業協會教育學院(Educational Institute of the American Hotel and Motel Association)取得服務業管理文憑，並於一九九六年八月取得倫敦American University工商管理學士學位。林女士於一九九八年五月取得美國Dominican University of California管理學文學碩士學位。林女士為本集團的共同創辦人之一。林女士自一九九七年四月起出任上海富陽董事一職。',
  	independentDirector:'獨立非執行董事',
  	cuishiwei:'崔士威先生，',
  	cswIntroduce:'自二零零六年六月起出任獨立非執行董事。崔先生於一九八六年七月獲中國吉林大學法學院頒授法學碩士學位。於一九八六年七月至一九九二年七月期間，崔先生為吉林大學法學院講師。崔先生曾在兩家全國性保險公司及沿海綠色家園有限公司（股份代號：01124）（其股份在聯交所上市）擔任高級管理職務。',
  	zhengzhipeng:'鄒耀明先生，',
  	zzpIntroduce:'持有香港大學會計及金融專業工商管理學士學位及倫敦大學專業會計學碩士學位。彼為特許公認會計師公會資深會員及香港會計師公會會員。彼在會計、核數、財務管理及企業融資方面擁有超過22年的經驗。自1995年至2001年，彼為一家國際會計師事務所的核數師。自2001年起，彼曾在香港的上市及私人公司擔任多個高級管理職位，包括財務總監和公司秘書。彼現為聯交所主板上市的李氏大藥廠控股有限公司（股份代號：00950）之財務總監及公司秘書。',
  	linjuncai:'林俊才先生，',
  	ljcIntroduce:'自二零一七年九月十九日起出任獨立非執行董事。林先生於一九九零年獲香港大學頒授社會科學學士學位，並於一九九七年取得香港律師資格。林先生曾於國際法律事務所及跨國上市公司提供法律顧問服務。彼於企業融資、公司及業務相關法律及法規之合規事宜擁有逾20年經驗。',
  	seniorManagement:'高級管理層',
  	lvzhuohua:'呂焯華先生，',
  	lzhIntroduce:'自二零一七年五月起為本公司之財務總監，及後於二零一八年四月十四日起同時兼任公司秘書。呂先生具有逾10年的會計及金融行業經驗。於加入本集團之前，呂先生曾於中瑞岳華（香港）會計師事務所有限公司擔任助理審計經理。彼持有Curtin University of Technology會計專業商學學士學位，並為澳洲會計師公會及香港會計師公會的會員。'
  },
	// 企業管治
  qiye:{
  	 boardDirectors:'董事會',
  	 boardDirectorsIntroduce:'本公司董事會現時由7名董事組成，包括3名執行董事江陳鋒先生（主席）、韓林先生及張秀華女士，1名非執行董事林倩如女士，3名獨立非執行董事鄒耀明先生、林俊才先生及崔士威先生。董事會成員分擔不同的角色及職能。董事會也設立了企業管治功能，並採納書面企業管治功能職權範圍。公司已設立董事會多元化政策。',
  	 auditCommittee:'審核委員會',
  	 auditCommitteeIntroduce:'審核委員會於二零零六年六月十日成立，並已採納書面職權範圍。<br>薪酬委員會由三名獨立非執行董事鄒耀明先生、林俊才先生及崔士威先生組成，而崔士威先生為薪酬委員會主席。',
  	 compensationCommittee:'薪酬委員會',
  	 compensationIntroduce:'薪酬委員會於二零零六年六月十日成立，並已採納書面職權範圍。<br>薪酬委員會由三名獨立非執行董事鄒耀明先生、林俊才先生及崔士威先生組成，而崔士威先生為薪酬委員會主席。',
  	 nominationsCommittee:'提名委員會',
  	 nominationsIntroduce:'提名委員會於二零零六年六月十日成立，並已採納書面職權範圍。<br>提名委員會由一名執行董事江陳鋒先生及兩名獨立非執行董事鄒耀明先生及林俊才先生組成，而江陳鋒先生為提名委員會主席。',
  	 executiveCommittee:'執行委員會',
  	 executive:'執行委員會於二零零七年一月十二日成立，並已採納書面職權範圍。<br>執行委員會由三名執行董事江陳鋒先生、韓林先生及張秀華女士組成，而江陳鋒先生為執行委員會主席。'
  },
  // 集團架構
  jituan:{
  	totalTitle1:'中國元素，全球視野',
  	totalTitle2:'不斷追求自我突破，持續創新',
  	JGTitleTouzi:'房地產投資管理',
  	JGContentTouzi:'富陽(中國)控股建立了服務全球華人的資產管理團隊，憑借豐富的經驗，掌握著前沿的本地市場知識和綜合管理能力，幫助客戶實現資產價值優化，為客戶提供評估咨詢，戰略顧問，市場研究，項目開發與管理，項目租賃銷售代理，物業與資產管理等服務。',
  	JGTitleJinrong:'房地產金融業務',
  	JGContentJinrong:'富陽(中國)控股以房產業務為核心，對大數據進行分析和挖掘，幫助優質投資標的與資本對接，實現資金的高效配置，保障客戶房地產開發過程的順利進行，促進房地產再生產過程中的資金良性循環。',
  	JGTitleXiaoshou:'房地產銷售業務',
  	JGContentXiaoshou:'富陽(中國)控股擁有專業的房地產銷售管理系統，利用先進的IT信息技術，結合自身22年的房地產專業經驗，幫助客戶在當前的行業經營形勢下，對銷售各個環節實時監控，實現業務流、信息流、資金流的整合管理。',
  	JGTitleXinxin:'房地產信息業務',
  	JGContentXinxin:'富陽(中國)控股以全渠道信息咨詢服務系統，秉承「全面、及時、準確、適用、經濟」的專業追求，為客戶提供房地產開發信息、房地產市場供求信息、房地產交易信息等相關咨詢服務。'
  },
	// 經典案例
	yewu:{
		invest:'房地產投資管理',
		caifuTitle:'上海財富海景花園',
		caifuIntroduce:'陸家嘴一線江景小豪宅',
		operatingManagement:'房地產金融業務',
		hongqiaoTitle:'上海虹橋國際科技廣場',
		hongqiaoIntroduce:'虹橋國際級企業總部',
		crossoverMarketing:'房地產銷售業務',
		hainanTitle:'海南雅居樂清水灣',
		hainanIntroduce:'佔地2萬畝，私屬12公裡海岸線，面向全國的度假聖品',
		putishu0:'房地產信息業務',
		putishu1:'金邊菩提樹',
		putishu2:'亞洲之星，東盟之鑽'
	},
	//	國內個案
	GNgean:{
		Tc:'太仓 - 月星 . 星悦府',
		TcContent:'一府定城央，悦享新境界',
		langshi:'东台 - 朗诗 . 世纪绿郡',
		langshiContent:'匠心匠铸造健康人居',
		yuanrong:'南通 - 圆融 . 玺悦',
		yuanrongContent:'市北圆融心，东方奢雅宅',
		yongle:'上海 - 荣乐水岸',
		rongleContent:'松江老城心，最近繁华处',
		huaqing:'六安 - 华强 . 一号公馆',
		huaqingContent:'一生一城，共享美好',
		qiyun:'启东 - 启运上城',
		qiyunContent:'启运启天下，上城上人生',
		dafeng:'大丰 - 天居珑悦府',
		dafengContent:'天成雅境，府悦春秋',

		
		NTTitle:'南通-順發御園',
		NTContent:'大玩家、朋友圈、趣院子<br>軍山下300畝純墅區',
		XJZYTitle:'鹽城 - 西郊莊園',
		XJZYContent:'墅以西為貴241-402m2<br>法式莊園別墅，一城仰望',
		BLGGTitle:'南通 - 巴黎公館',
		BLGGContent:'全城第1景<br>天安板塊，市中心生活地標',
		WLJHTitle:'宜昌 - 伍領江湖',
		WLJHContent:'預見繁華 · 預約芳華<br>67-155m2龍盤湖江景高層',
		YJTDTitle:'宜昌 - 御景天地',
		YJTDContent:'九景之境，<br>五感山居三萬方生態園林，<br>典雅慢生活',
		LYCTitle:'大豐 - 望園 · 來茵城',
		LYCContent:'最高100米超寬棟距，<br>鬧中取靜實景現房，<br>生活之道',
		YLSATitle:'上海 - 榮樂水岸',
		YLSAContent:'松江老城心，最近繁華處<br>三期新品，王者歸來',
		NTBYTitle:'南通 - 南通別業',
		NTBYContent:'一府封疆 · 墅藏東方',
		QCWCTitle:'嘉興 - 清池溫泉度假村',
		QCWCContent:'滬杭示範區，小鎮經濟圈<br>私人定制金獎溫泉度假村',
		JHCTitle:'南通 - 景華城',
		JHCContent:'商圈、學區、地鐵、現房<br>身處好風景，舉步皆繁華',
		XSGTitle:'寧波 - 象山港文化廣場',
		XSGContent:'品牌搶進·文化產金<br>搶鋪·落戶·金學區'
	},
	//海外置業
	hyzy:{
		hyzyText1:'富陽海外置業用全球戰略眼光來尋覓優質海外資產，以具實效的市場資訊和專業的投資分析，助您做出更英明的投資決策。',
		hyzyText2:'近年來富陽海外置業深耕歐美、東南亞高端房地產業務，與諸多知名海外房產企業建立合作關係。富陽海外置業以專業的海外專家團隊，從資產篩選、稅務咨詢、銀行貸款到交易流程，為您提供全程置業咨詢。',
		hyzyText3:'伴隨著經濟的迅速發展，中國私人財富和高淨值人群正保持著快速增長，人們更加重視財富保障和傳承，資產配置趨向多元化，海外置業的需求愈發強烈。'
	},
  // 一帶一路
  road:{
  	sichou1:'2013年9月和10月，中國政府先後提出共建「絲綢之路經濟帶」和「21世紀海上絲綢之路」（以下簡稱「一帶一路」，英文簡稱The Belt and Road）的倡議，得到國際社會的高度關注和有關國際的積極響應。2015年3月28日，國家發展改革委、外交部、商務部聯合發佈了《推動共建絲綢之路經濟帶和21世紀海上絲綢之路的願景與行動》，倡導共建「一帶一路」致力於亞歐非大陸及附近海洋的互聯互通，建立和加強沿線各國互聯互通夥伴關係，構建全方位、多層次、復合型的互聯互通網絡，實現沿線各國多元、自主、平衡、可持續的發展。',
  	sichou2:'在「一帶一路」的倡議引領下，每年亞太地區基礎設施建設的資金需求大概有7000億美元，「一帶一路」建設積極效應逐步顯現，基礎建設的逐漸完善也讓東南亞的房產市場成為海外投資新寵。以「一帶一路」沿線的泰國、柬埔寨、馬來西亞三國的海外房產投資數據為基礎，結合三個國家的國別宏觀概況和當地房產市場分析，意在幫助國人瞭解相關國家的經濟發展現狀和海外房產投資形勢。',
  	map1:'數據顯示泰國曼谷房地產均價折合人民幣約為25700元/㎡，年均漲幅高達12.3%；泰國、柬埔寨、馬來西亞三國的熱門城市均價均已超過一萬，',
  	map2:'金邊房地產均價超過人民幣兩萬元每平米。值得注意的是：三國租金收益率一般在5%-8%，相比北京上海1%的租金收益率要高很多。',
  	roadTitle1:'「一帶一路」三國國情概覽',
  	gdpContent:'「一帶一路」三國的GDP，人口總數均呈現增長趨勢。',
  	roadTitle2:'一帶一路中的東南亞 - 新財富 新通路',
  	caifuContent1:'「一帶一路」倡議提出的三年多來，國內和國際兩方面都取得豐碩成果和積極的影響，大力推動東南亞的協同發展。目前我國已跟四十多個國家和國際組織簽署了五十多份共建協議，促進了國家間的合作，帶動了泰國，馬來西亞，柬埔寨等國家的GDP，人口總數，房地產市場價格的大幅增長。以綠城，碧桂園為首的知名房地產企業更是紛紛轉向東南亞市場。',
  	caifuContent2:'目前主流國家均已對中國人開放房地產購買權，吸引了中國海外投資大軍的目光，數據顯示中國人最新換購置房產的城市為曼谷，目前曼谷房地產均價約25700元，芭提雅、普吉島等城市也比較受歡迎。100萬在北京、上海等地已經很難買到房子的情況下，在「一帶一路」三國中還有更多財富的選擇。',
  	thL1:'數據',
  	thL2:'馬來西亞',
  	thL3:'泰國',
  	thL4:'柬埔寨',
  	tbL11:'GDP',
  	tbL12:'296億美元',
  	tbL13:'395億美元',
  	tbL14:'180億美元',
  	tbL21:'GDP增長率',
  	tbL22:'4.95%',
  	tbL23:'2.81%',
  	tbL24:'7.03%',
  	tbL31:'人均GDP約',
  	tbL32:'9766美元',
  	tbL33:'5816美元',
  	tbL34:'1159美元',
  	tbL41:'互聯網普及率',
  	tbL42:'67.5%',
  	tbL43:'34.89%',
  	tbL44:'9%',
  	tbL51:'人口總數',
  	tbL52:'3033萬',
  	tbL53:'6796萬',
  	tbL54:'1558萬',
  	tbL61:'人口增長率',
  	tbL62:'1.42%',
  	tbL63:'0.34%',
  	tbL64:'1.6%',
  	tbL71:'城市人佔比',
  	tbL72:'74.71%',
  	tbL73:'50.37%',
  	tbL74:'20.72%',
  	tbL81:'進出口總額約',
  	tbL82:'10200563萬美元',
  	tbL83:'7262116萬美元',
  	tbL84:'375765萬美元',
  	tbL91:'實際利用外商直接投資額約',
  	tbL92:'15749萬美元',
  	tbL93:'6052萬美元',
  	tbL94:'312萬美元'
  },
	// 柬埔寨
	jpz:{
		projectIntroduce:'項目介紹',
		projectContent:'2017,跟著國家「一帶一路」賺大錢低門檻投資20年前的上海！柬埔寨首都金邊，政局穩定！GDP8%高速增長，年房價達30％漲幅！政府多項利好政策，吸引外資成倍增長！旅遊業發達租賃需求大，已成最佳海外房產投資國家！全面美金流通，貨幣強勢無外匯管制！房產租金高達10%回報，比股票、基金更迷人！永久產權，東盟十國首都房價窪地，更具吸引力！一帶一路，泛亞鐵路2020年通車！毗鄰百盛商場，卡塔爾航空五星級酒店，大型免稅商場！45％綠化，戶戶送車位，棟棟屋頂泳池！項目地段：柬埔寨首都金邊俄羅斯大道，毗鄰百盛商場！10分鐘直達金邊行政商務區和金邊旅遊開發區。',
		plwsIntroduce:'項目介紹',
		plwsContent1:'普羅旺斯公寓座落BKK1使館區，擁有得天獨厚的地理位置，區域內高級公寓林立，臨近大皇宮、Naga金界娛樂城、日本Aeon Mall全天候享不停精彩都市生活！',
		plwsContent2:'擁有普羅旺斯的6大理由：①一層５戶，私密單純。②燙金地段，坐享增值。③使館特區，稀缺小豪宅。④輕總價，坐擁美金資產。 ⑤配套齊全，拎包入住。⑥百強優質房客即將入住，租金無憂。',
		countryIntroduce:'國家介紹：尋找美金資產中的價值窪地',
		countryContent1:'柬埔寨位於亞洲東南部的中南半島南部。大多數人對柬埔寨的印象，來自於世界七大奇景之一的吳哥窟，以及充滿著強烈對比的人文風情和柬埔寨特有的風土景致，為遊客留下了視覺與心理上的巨大震撼，使得柬埔寨深受世界各地的旅客喜愛。',
		countryContent2:'近年來，柬埔寨經濟高速穩定的發展，吸引了大量的國際資本進駐投資。每一次到達首都金邊都會讓人感受到城市風貌不斷在蛻變，天際線四處看到是高聳的建築起重機，徬佛置身在當年的上海浦東新區一般，這就是柬埔寨市場火熱的象徵。',
		clickBtnText:'點擊進入'
	},
	// 菩提樹項目介紹
	jpzProject:{
		jpzPTitle1:'城市中央  盡享繁華',
		jpzPContent1:'往往1%的區域，承擔起了一座城市99%的盛名<br>菩提樹公寓，雄踞金邊城市核心區，位於俄羅斯大道<br>毗鄰百盛商場，與金邊國際機場隔街相望<br>距離金邊皇家醫院僅10分鐘車程<br>15分鐘即達金邊高爾夫俱樂部，即刻融入精彩國際都市生活<br>',
		jpzPContentMO1:'往往1%的區域，承擔起了一座城市99%的盛名，菩提樹公寓，雄踞金邊城市核心區，位於俄羅斯大道，毗鄰百盛商場，與金邊國際機場隔街相望，距離金邊皇家醫院僅10分鐘車程，15分鐘即達金邊高爾夫俱樂部，即刻融入精彩國際都市生活。',
		jpzPTitle2:'目之所及  皆是公園',
		jpzPContent2:'身處公園中，擁抱大自然<br>菩提樹公寓採用園林式景觀設計，45%的超高綠化率<br>超大的天台花園<br>用匠心將寧靜悠綠的花園做到極致<br>精雕細琢只為給您一個優雅環境<br>在繁華城央，實現一座城市的公園理想',
		jpzPContentMO2:'身處公園中，擁抱大自然，菩提樹公寓採用園林式景觀設計，45%的超高綠化率，超大的天台花園，用匠心將寧靜悠綠的花園做到極致，精雕細琢只為給您一個優雅環境，在繁華城央，實現一座城市的公園理想。',
		jpzPTitle3:'生得靈動  活得美麗',
		jpzPContent3:'從人性化的設計開始，菩提樹公寓始終印證業主的尊貴身份<br>公寓內的中央花園採用現代化人居設計<br>為業主的社交會友提供了一個完美空間，天台花園，無邊泳池<br>露天咖啡館，兒童遊樂場等每一處的精心規劃<br>都是為了給您一個平靜而舒適的五星生活<br>',
		jpzPContentMO3:'從人性化的設計開始，菩提樹公寓始終印證業主的尊貴身份，公寓內的中央花園採用現代化人居設計，為業主的社交會友提供了一個完美空間，天台花園，無邊泳池，露天咖啡館，兒童遊樂場等每一處的精心規劃，都是為了給您一個平靜而舒適的五星生活。'
	},
	// 普羅旺斯項目介紹
	plwsProject:{
		plwsPTitle1:'BKK1使館區，南法風情高層建築',
		plwsPContent1:'本案位於柬埔寨核心區域BKK1中302路，這裡是僑民、企業和高淨值居民的聚集地，地段尊貴稀缺，採南法風情高層建築，視野極佳，環境單純，鬧中取靜，出行順暢，深受海內外高端人士喜愛收藏。',
		plwsPTitle2:'拎包入住，星級配套，置業無憂',
		plwsPContent2:'普羅旺斯公寓擁有完備多功能的生活設施，精心規劃無邊泳池、空中花園和健身房等公共休閒區域，同時，星級物業的貼心管理服務，傢具配套齊全，投資，自住，出租，高枕無憂，讓住戶們即買即享受，盡情揮灑國際大都會生活。'
	},
	// 柬埔寨國家介紹
	jpzState:{
		USDTitle:'尋找美金資產中的價值窪地',
		USDContent1:'柬埔寨位於亞洲東南部的中南半島南部。大多數人對柬埔寨的印象，來自於世界七大奇景之一的吳哥窟，以及充滿著強烈對比的人文風情和柬埔寨特有的風土景致，為遊客留下了視覺與心理上的巨大震撼，使得柬埔寨深受世界各地的旅客喜愛。',
		USDContent2:'近年來，柬埔寨經濟高速穩定的發展，吸引了大量的國際資本進駐投資。每一次到達首都金邊都會讓人感受到城市風貌不斷在蛻變，天際線四處看到是高聳的建築起重機，徬佛置身在當年的上海浦東新區一般，這就是柬埔寨市場火熱的象徵。',
		newStandard:'柬埔寨 — 海外房產置業新標的',
		newStandardC1:'1.從當前通脹水平看，人民幣未來存在不小的貶值壓力，匯率下跌趨勢已基本確定',
		newStandardC2:'2.美元匯率近幾年持續走高，已成為最保值的貨幣之一，投資美元資產可以起到保值的作用',
		jpzChooseTitle:'選擇柬埔寨置業的5大理由',
		jpzChooseC1:'1.市場經濟騰飛，GDP連續6年增長超過7%，是全球近十年來成長最快速的國家之一',
		jpzChooseC2:'2.地處東盟中心，更是「一帶一路」的樞紐，大量基礎設施建設投資，帶動樓市增長',
		jpzChooseC3:'3. 超高人口紅利，亞洲平均年齡最低的國家，擁有眾多年輕勞動力，人口紅利未來帶動經濟強力增長',
		jpzChooseC4:'4. 超高投資價值，金邊租金收益率可達10%，居東南亞城市之首，外國人持護照即可購買，並擁有永久產權',
		jpzChooseC5:'5. 美元資產抗貶值，投資柬埔寨資產即是投資美元資產，美元匯率近年來持續走高，強勢貨幣，財富保值更增值',
		jpzCityTitle:'柬埔寨三大城市 — 歷史與現代的完美交融',
		jpzCity1:'金邊市',
		jpzCityContent1:'金邊是柬埔寨首都，地處柬埔寨中部平原，處於湄公河、洞里薩河和巴薩河的交匯處，面積289平方公里，人口約130萬。自1434年起成為柬首都，是全國政治、經濟、文化中心，也是國內、國際航空和水陸交通樞紐。',
		jpzCity2:'西哈努克市',
		jpzCityContent2:'西哈努克市舊稱磅遜市，位於柬南部，西臨泰國灣，距金邊約240公里，擁有柬唯一的國際海港。該市氣候濕潤，海灘聞名，是柬著名的度假勝地。整座島上沒有一條公路，是一個不受塵世沾染的世外桃源。',
		jpzCity3:'暹粒省',
		jpzCityContent3:'暹粒省文物古蹟繁多，旅遊資源豐富，共有古寺廟292個，被聯合國教科文組織列為世界七大奇跡之一的著名吳哥古蹟就坐落在暹粒市以北6公里處，中南半島最大的淡水湖——洞里薩湖位於該省南端。',
	},
	// 中介店
	zjd:{
		zjdIntroduce:'富陽（中國）控股深耕中國市場，以「中國元素，全球視野」提供客戶多元化，優質化的房地產專業信息及管理服務內容，並在金邊設立富陽房地產公司及中介門店，讓廣大的海內外客戶享有便捷，專業，全方位的高效服務。',
		zjdTitle:'富陽房地產中介店主營',
		zjdIcon1:'資產管理',
		zjdIcon2:'土地',
		zjdIcon3:'廠房',
		zjdIcon4:'寫字樓',
		zjdIcon5:'二手房',
		zjdIcon6:'租房',
		zjdIcon7:'新房',
		zjdCompany:'富陽房地產公司及中介門店',
		zjdCompanyContent:'為高端客戶提供更多元化的房產政策稅務咨詢，投資購置，代租，代售，代管一站式的房地產管理服務。',
		guanjiaTitle:'專屬私人管家',
		guanjiaContent:'提供一對一客戶專屬私人管家服務，讓業主不必對跨國物業管理擔心，所有關於房屋的租賃、買賣、日常管理、家私維修，業主可以直接點對點的咨詢自己的私人管家。',
		zulinTitle:'租賃與買賣',
		zulinContent1:'• 免費提供掛牌信息',
		zulinContent2:'• 提供二手房買賣服務，按成交總價的1%收取中介費',
		zulinContent3:'• 提供房屋長租、短租服務：1年以上租約收取1個月的租金為中介費',
		daishoukuanTitle:'代收款',
		daishoukuanContent1:'• 定期催收租金，並轉賬至業主賬戶',
		daishoukuanContent2:'（匯款手續費由業主承擔）',
		daishoukuanContent3:'• 代繳相關費用',
		daishoukuanContent4:'（年度房屋稅、物業管理費、公共水電費等）',
		qingjieTitle:'居家清潔服務',
		qingjieContent1:'• 根據業主要求可隨時提供單次物業清潔',
		qingjieContent2:'（提供清潔費用明細）',
		qingjieContent3:'• 每次租期結束後，免費提供一次物業整套清潔服務',
		qingjieContent4:'• 洗衣服務(根據實際洗衣重量、種類計價)',
		xiushanTitle:'居家修繕',
		xiushanContent1:'• 物業主體修繕：例如上下水管道、房屋牆面等主體結構在保修範圍以外的維修（根據維修清單實報實銷）',
		xiushanContent2:'• 物業室內傢具、家電維修（根據維修清單實報實銷）',
		qitaTitle:'其他附加服務',
		qitaContent1:'• 定期巡視空屋並視頻空屋現狀',
		qitaContent2:'• 代訂酒店、租車',
		qitaContent3:'• 通過我們的管理公司於當地同類型房屋租賃，業主可享有一定折扣優惠入住',
		qitaContent4:'• 免費咨詢當地房地產相關法律法規',
		qitaContent5:'• 當地的房地產市場行情，包含售價、租金'
	},
	vhouse:{
		vhouseTitle1:'小宅大作 开启你的V生活<br>ផ្ទះប្រណីខ្នាតតូច  ចាប់ផ្តើមជីវិត V របស់អ្នក',
		vhouseContent1:'上风 上景 上层家 <br>立足城市居所让生活更出彩<br>俯瞰拥抱绿意美景，出门连线国际商圈<br>景致意境 尽收眼底<br>兼得繁华与宁静，成就都市新生活<br>拥有V-HOUSE高层景观美宅<br>从此生活由你来定义 <br><br>ទីតាំងល្អ  ទេសភាពល្អ  ផ្ទះល្អ  <br>ធ្វើឱ្យការរស់នៅរបស់អ្នកនៅទីក្រុងកាន់តែស្រស់បំព្រង  <br>មានទេសភាពបៃតង   នៅជុំវិញតំបន់ពាណិជ្ជកម្មអន្តរជាតិ  <br>សោភ័ណ្ឌភាពបែបលក្ខណៈសិល្បៈ  ទេសភាពធំទូលាយ  <br>មានទាំងវិបុលភាព និងភាពស្ងប់ស្ងាត់  នេះជាជីវិតថ្មីនៅក្នុងទីក្រុង។  <br>ជាមួយនឹងផ្ទះ V-HOUSE ជាន់ខ្ពស់មានទេសភាពដ៏ស្រស់ស្អាត  <br>ជីវិតរបស់អ្នកនឹងមានភាពស្រស់ស្រាយ។',
		vhouseTitle2:'大视野 高层上 风景这边独好 <br> ទេសភាពធំល្វឹងល្វើយ ខ្ពស់ស្រឡះ សោភ័ណ្ឌភាពពិសេស',
		vhouseContent2:'现代人们的生活在高速发展的社会中一丝不苟的运转着，是时候寻觅一处舒适场所让在都市中忙碌的身心全方位放松。多朝向醉美景观，视野全面无遮挡，俯瞰绿意美景，都市繁华尽收眼底。暖阳洒进，让所有的烦恼与疲惫无影无踪。华灯初上，万家的灯火让心绪无比温馨。住进城心“V-House”，成就人生新高度。一眼望去，蔚然无限。鸟语花香从容交错，和谐安详的景致平添温暖。周边配套齐全，临近国际商圈。不仅繁华垂手可得，更拥有难得的宁静氛围。<br><br>ជីវភាពរស់នៅរបស់មនុស្សសម័យថ្មីកំពុងតែមានការវិវត្តនៅក្នុងសង្គមដែលមានការរីកចម្រើនយ៉ាងឆាប់រហ័ស។ ដល់ពេលហើយដែលត្រូវស្វែងរកកន្លែងសោយសុខដើម្បីបន្ធូរអារម្មណ៍ទាំងផ្លូវកាយនិងផ្លូវចិត្តនៅក្នុងការរស់នៅក្នុងទីក្រុងដ៏មមាញឹក។ ផ្តោតជាសំខាន់លើទេសភាពដ៏ស្រស់ស្អាត អាចមើលធំល្វឹងល្វើយ និងមើលទេសភាពបៃតង និងអាចមើលទិដ្ឋភាពទីក្រុងមានសភាពអ៊ូអរ។ ពន្លឺព្រះអាទិត្យដ៏កក់ក្តៅធ្វើឱ្យអ្នកបាត់កង្វល់ និងភាពនឿយណាយ។ នៅពេលភ្លើងពេលរាត្រីបានបំភ្លឺឡើង ពន្លឺភ្លើងចេញពីផ្ទះរាប់ពាន់ផ្ទះធ្វើឱ្យអារម្មណ៍របស់អ្នកកក់ក្តៅ។ ស្ថិតនៅចំណកណ្តាលនៃទីក្រុង  "V-House" បង្កើតលំដាប់ថ្នាក់ខ្ពស់ថ្មីនៃការរស់នៅ។ គ្រាន់តែក្រឡេកមើលភ្លាម វិសាភាពធំល្វឹងល្វើយគ្មានព្រំដែន។ សំឡេងបក្សាបក្សី និងក្លិនផ្កាលាយចំរុះគ្នា ហើយទេសភាពសុខដុមរមនានិងសន្តិភាពបង្កើនអារម្មណ៍កក់ក្ដៅ។ តំបន់ជុំវិញមានបំពាក់គ្រឿងសង្ហារិមគ្រប់គ្រាន់ ហើយនៅជិតតំបន់ពាណិជ្ជកម្មអន្តរជាតិ។ មិនតែមានភាពរីកចម្រើន ថែមទាំងប៉ុន្តែមានបរិយាកាសស្ងប់ស្ងាត់ចង់រស់នៅ។',
		vhouseTitle3:'大荣耀   当房子变成家 一切悠然自得 <br>ជោគជ័យដ៏អស្ចារ្យ នៅពេលដែលផ្ទះក្លាយទៅជាកម្មសិទ្ធិរបស់អ្នក ធ្វើឱ្យអ្នកមានអារម្មណ៍ស្រណុកសុខស្រួល។',
		vhouseContent3:'习惯了快节奏的生活，喜欢与时间赛跑。但在这里，一切皆可慢慢享受。V-House公寓紧邻TK商圈与永旺2期。每一户都采用科学户型设计，整体动线流畅合理，每户配备观景大阳台为住户提供欣赏全城美景的私密空间。把美景独享亦或分享，皆为美事。挑一个温暖的下午，蜷在慵懒的沙发上看一部期待已久的电影，或和三两好友，品茗小酌各自的精彩。在这里，与自己的理想不期而遇。<br><br>អ្នកមានទម្លាប់រស់នៅក្នុងជីវិតដ៏មមាញឹកឆាប់រហ័ស និងចូលចិត្តប្រណាំងប្រជែងជាមួយពេលវេលា។ ប៉ុន្តែនៅទីនេះអ្នកអាចសោយសុខគ្រប់យ៉ាងដោយសន្សឹមៗ។ ខុនដូ V-House មានទីតាំងស្ថិតនៅជាប់តំបន់ពាណិជ្ជកម្មទួលគោក និងផ្សារទំនើបអ៊ីអ៉នពីរ។ផ្ទះនីមួយៗប្រើប្រាស់ការរចនាប្លង់លក្ខណៈវិទ្យាសាស្រ្តជាមួយនឹងចលនាទាំងមូលដែលលក្ខណៈរលូន និងសមស្រប។ ផ្ទះនីមួយៗមានរានហាលធំទូលាយដែលផ្តល់អ្នកនូវកន្លែងឯកជនដើម្បីរីករាយគយគន់ភាពស្រស់ស្អាតនៃទីក្រុង។ វាជារឿងល្អក្នុងការរីករាយ ឬចែករំលែក។ ឆ្លៀតពេលរសៀល អង្គុយលើសាឡុងមើលភាពយន្ត ឬជជែកកម្សាន្តសប្បាយជាមួយមិត្តភ័ក្តិរបស់អ្នកនិងរីករាយទទួលទានទឹកតែល្អ។',
		vhouseTitle4:'大价值 一屋在手 精彩生活轻松拥有 <br>គុណតម្លៃដ៏អស្ចារ្យ  ជីវិតដ៏អស្ចារ្យនិងងាយស្រួលក្នុងផ្ទះរបស់អ្នកផ្ទាល់',
		vhouseContent4:'25岁买房，30岁而立，偌大的城市，青春有限，自由无价，现在你也能轻松当房东！省下几件名牌华服，让年纪轻轻的当下就提早拥有一间优质的家！V-House精品公寓秉承现代人居理念，小户型，轻总价，买得起，住得好。所在区域潜力巨大，自住或投资出租，即买即享受。依靠，一个叫家的地方。我们的自由天地，完全属于自己！空间独立，休闲放松，更多开心，满足与安全感。在属于自己的一方天地里，生活可以无限精彩！独立自主，轻松置业，是时候了。<br><br>ទិញផ្ទះនៅអាយុ 25 ឆ្នាំ ហើយកសាងស្នាដៃនៅអាយុ 30។ ជាមួយនឹងទីក្រុងធំ យុវ័យរបស់អ្នកមានដែនកំណត់ មានសេរីភាពហើយមិនអាចកាត់ថ្លៃ ឥឡូវនេះអ្នកអាចក្លាយជាម្ចាស់ផ្ទះបានយ៉ាងងាយស្រួល! សន្សំថវិការបស់អ្នកដើម្បីទិញផ្ទះល្អមួយខ្នងនៅពេលអ្នកនៅក្មេង! ខុនដូ V-House បង្កប់នូវគោលគំនិតថ្មីនៃការរស់នៅ  មានទំហំតូច តម្លៃសមរម្យនិងងាយស្រួលក្នុងការរស់នៅប្រកបដោយផាសុកភាព។ តំបន់នេះមានសក្តានុពលច្រើន ដូច្នេះអ្នកអាចរស់នៅ ឬវិនិយោគដោយដាក់ជួល។ ទិញដើម្បីសោយសុខ។ កន្លែងនេះហៅថាផ្ទះគ្រួសារ។ ពិភពរបស់យើងគឺសេរីភាពរបស់យើង! អ្នកអាចធ្វើជាម្ចាស់ផ្ទះដើម្បីភាពឯកជន ការសម្រាកលំហែ សុភមង្គលសេចក្តីពេញចិត្តនិងសុវត្ថិភាពរបស់អ្នក។ នៅក្នុងពិភពរបស់អ្នក ជីវិតរបស់អ្នកអាចមានភាពអស្ចារ្យ! ដល់ពេលហើយដែលត្រូវមានភាពឯករាជ្យម្ចាស់ការ ដោយទិញអចលនទ្រព្យដ៏អស្ចារ្យនេះ។',
		soonOpen:'即将引爆公开 <br>បែបផែន៖ជិតមកដល់ក្នុងពេលឆាប់ៗនេះហើយ',
		
		vhPCT1:'小宅大作 开启你的V生活',
		vhPCC1:'上风 上景 上层家 <br>立足城市居所让生活更出彩<br>俯瞰拥抱绿意美景，出门连线国际商圈<br>景致意境 尽收眼底<br>兼得繁华与宁静，成就都市新生活<br>拥有V-HOUSE高层景观美宅<br>从此生活由你来定义',
		vhPCTJ1:'ផ្ទះប្រណីខ្នាតតូច  ចាប់ផ្តើមជីវិត V របស់អ្នក',
		vhPCCJ1:'ទីតាំងល្អ  ទេសភាពល្អ  ផ្ទះល្អ  <br>ធ្វើឱ្យការរស់នៅរបស់អ្នកនៅទីក្រុងកាន់តែស្រស់បំព្រង  <br>មានទេសភាពបៃតង   នៅជុំវិញតំបន់ពាណិជ្ជកម្មអន្តរជាតិ  <br>សោភ័ណ្ឌភាពបែបលក្ខណៈសិល្បៈ  ទេសភាពធំទូលាយ  <br>មានទាំងវិបុលភាព និងភាពស្ងប់ស្ងាត់  នេះជាជីវិតថ្មីនៅក្នុងទីក្រុង។  <br>ជាមួយនឹងផ្ទះ V-HOUSE ជាន់ខ្ពស់មានទេសភាពដ៏ស្រស់ស្អាត  <br>ជីវិតរបស់អ្នកនឹងមានភាពស្រស់ស្រាយ។',
		
		vhPCT2:'大视野 高层上 风景这边独好',
		vhPCC2:'现代人们的生活在高速发展的社会中一丝不苟的运转着，是时候寻觅一处舒适场所让在都市中忙碌的身心全方位放松。多朝向醉美景观，视野全面无遮挡，俯瞰绿意美景，都市繁华尽收眼底。暖阳洒进，让所有的烦恼与疲惫无影无踪。华灯初上，万家的灯火让心绪无比温馨。住进城心“V-House”，成就人生新高度。一眼望去，蔚然无限。鸟语花香从容交错，和谐安详的景致平添温暖。周边配套齐全，临近国际商圈。不仅繁华垂手可得，更拥有难得的宁静氛围。',
		vhPCTJ2:'ទេសភាពធំល្វឹងល្វើយ ខ្ពស់ស្រឡះ សោភ័ណ្ឌភាពពិសេស',
		vhPCCJ2:'ជីវភាពរស់នៅរបស់មនុស្សសម័យថ្មីកំពុងតែមានការវិវត្តនៅក្នុងសង្គមដែលមានការរីកចម្រើនយ៉ាងឆាប់រហ័ស។ ដល់ពេលហើយដែលត្រូវស្វែងរកកន្លែងសោយសុខដើម្បីបន្ធូរអារម្មណ៍ទាំងផ្លូវកាយនិងផ្លូវចិត្តនៅក្នុងការរស់នៅក្នុងទីក្រុងដ៏មមាញឹក។ ផ្តោតជាសំខាន់លើទេសភាពដ៏ស្រស់ស្អាត អាចមើលធំល្វឹងល្វើយ និងមើលទេសភាពបៃតង និងអាចមើលទិដ្ឋភាពទីក្រុងមានសភាពអ៊ូអរ។ ពន្លឺព្រះអាទិត្យដ៏កក់ក្តៅធ្វើឱ្យអ្នកបាត់កង្វល់ និងភាពនឿយណាយ។ នៅពេលភ្លើងពេលរាត្រីបានបំភ្លឺឡើង ពន្លឺភ្លើងចេញពីផ្ទះរាប់ពាន់ផ្ទះធ្វើឱ្យអារម្មណ៍របស់អ្នកកក់ក្តៅ។ ស្ថិតនៅចំណកណ្តាលនៃទីក្រុង  "V-House" បង្កើតលំដាប់ថ្នាក់ខ្ពស់ថ្មីនៃការរស់នៅ។ គ្រាន់តែក្រឡេកមើលភ្លាម វិសាភាពធំល្វឹងល្វើយគ្មានព្រំដែន។ សំឡេងបក្សាបក្សី និងក្លិនផ្កាលាយចំរុះគ្នា ហើយទេសភាពសុខដុមរមនានិងសន្តិភាពបង្កើនអារម្មណ៍កក់ក្ដៅ។ តំបន់ជុំវិញមានបំពាក់គ្រឿងសង្ហារិមគ្រប់គ្រាន់ ហើយនៅជិតតំបន់ពាណិជ្ជកម្មអន្តរជាតិ។ មិនតែមានភាពរីកចម្រើន ថែមទាំងប៉ុន្តែមានបរិយាកាសស្ងប់ស្ងាត់ចង់រស់នៅ។',
		
		vhPCT3:'大荣耀   当房子变成家 一切悠然自得',
		vhPCC3:'习惯了快节奏的生活，喜欢与时间赛跑。但在这里，一切皆可慢慢享受。V-House公寓紧邻TK商圈与永旺2期。每一户都采用科学户型设计，整体动线流畅合理，每户配备观景大阳台为住户提供欣赏全城美景的私密空间。把美景独享亦或分享，皆为美事。挑一个温暖的下午，蜷在慵懒的沙发上看一部期待已久的电影，或和三两好友，品茗小酌各自的精彩。在这里，与自己的理想不期而遇。',
		vhPCTJ3:'ជោគជ័យដ៏អស្ចារ្យ នៅពេលដែលផ្ទះក្លាយទៅជាកម្មសិទ្ធិរបស់អ្នក ធ្វើឱ្យអ្នកមានអារម្មណ៍ស្រណុកសុខស្រួល។',
		vhPCCJ3:'អ្នកមានទម្លាប់រស់នៅក្នុងជីវិតដ៏មមាញឹកឆាប់រហ័ស និងចូលចិត្តប្រណាំងប្រជែងជាមួយពេលវេលា។ ប៉ុន្តែនៅទីនេះអ្នកអាចសោយសុខគ្រប់យ៉ាងដោយសន្សឹមៗ។ ខុនដូ V-House មានទីតាំងស្ថិតនៅជាប់តំបន់ពាណិជ្ជកម្មទួលគោក និងផ្សារទំនើបអ៊ីអ៉នពីរ។ផ្ទះនីមួយៗប្រើប្រាស់ការរចនាប្លង់លក្ខណៈវិទ្យាសាស្រ្តជាមួយនឹងចលនាទាំងមូលដែលលក្ខណៈរលូន និងសមស្រប។ ផ្ទះនីមួយៗមានរានហាលធំទូលាយដែលផ្តល់អ្នកនូវកន្លែងឯកជនដើម្បីរីករាយគយគន់ភាពស្រស់ស្អាតនៃទីក្រុង។ វាជារឿងល្អក្នុងការរីករាយ ឬចែករំលែក។ ឆ្លៀតពេលរសៀល អង្គុយលើសាឡុងមើលភាពយន្ត ឬជជែកកម្សាន្តសប្បាយជាមួយមិត្តភ័ក្តិរបស់អ្នកនិងរីករាយទទួលទានទឹកតែល្អ។',
		
		vhPCT4:'大价值 一屋在手 精彩生活轻松拥有',
		vhPCC4:'25岁买房，30岁而立，偌大的城市，青春有限，自由无价，现在你也能轻松当房东！省下几件名牌华服，让年纪轻轻的当下就提早拥有一间优质的家！V-House精品公寓秉承现代人居理念，小户型，轻总价，买得起，住得好。所在区域潜力巨大，自住或投资出租，即买即享受。依靠，一个叫家的地方。我们的自由天地，完全属于自己！空间独立，休闲放松，更多开心，满足与安全感。在属于自己的一方天地里，生活可以无限精彩！独立自主，轻松置业，是时候了。',
		vhPCTJ4:'គុណតម្លៃដ៏អស្ចារ្យ  ជីវិតដ៏អស្ចារ្យនិងងាយស្រួលក្នុងផ្ទះរបស់អ្នកផ្ទាល់',
		vhPCCJ4:'ទិញផ្ទះនៅអាយុ 25 ឆ្នាំ ហើយកសាងស្នាដៃនៅអាយុ 30។ ជាមួយនឹងទីក្រុងធំ យុវ័យរបស់អ្នកមានដែនកំណត់ មានសេរីភាពហើយមិនអាចកាត់ថ្លៃ ឥឡូវនេះអ្នកអាចក្លាយជាម្ចាស់ផ្ទះបានយ៉ាងងាយស្រួល! សន្សំថវិការបស់អ្នកដើម្បីទិញផ្ទះល្អមួយខ្នងនៅពេលអ្នកនៅក្មេង! ខុនដូ V-House បង្កប់នូវគោលគំនិតថ្មីនៃការរស់នៅ  មានទំហំតូច តម្លៃសមរម្យនិងងាយស្រួលក្នុងការរស់នៅប្រកបដោយផាសុកភាព។ តំបន់នេះមានសក្តានុពលច្រើន ដូច្នេះអ្នកអាចរស់នៅ ឬវិនិយោគដោយដាក់ជួល។ ទិញដើម្បីសោយសុខ។ កន្លែងនេះហៅថាផ្ទះគ្រួសារ។ ពិភពរបស់យើងគឺសេរីភាពរបស់យើង! អ្នកអាចធ្វើជាម្ចាស់ផ្ទះដើម្បីភាពឯកជន ការសម្រាកលំហែ សុភមង្គលសេចក្តីពេញចិត្តនិងសុវត្ថិភាពរបស់អ្នក។ នៅក្នុងពិភពរបស់អ្នក ជីវិតរបស់អ្នកអាចមានភាពអស្ចារ្យ! ដល់ពេលហើយដែលត្រូវមានភាពឯករាជ្យម្ចាស់ការ ដោយទិញអចលនទ្រព្យដ៏អស្ចារ្យនេះ។',
		
	},
  // 投資者關係
  touzi:{
  	filesize:'文件大小：',
  	hits:'點擊次數：',
  	updatetime:'更新時間：',
  	viewDetails:'查看詳情',
  	clickDownload:'點擊下載',
  	previous:'上一頁',
  	next:'下一頁',
  	jumpTo:'跳轉到'
  },
	// 聯繫我們
	lianxi:{
		SHAddress:'上海公司',
		SHAddressXQ:'地址：上海市浦東新區世紀大道1500號東方大廈9樓    ',
		SHAddressDH:'    電話：021-68419699',
		SHAddressCZ:'  傳真：021-68419399',
		SHAddressYB:'郵編：200122',
		XGAddress:'香港地址',
		XGAddressXQ:'地址：香港九龍尖沙咀廣東道21號海港城港威大廈第五座16樓    ',
		XGAddressDH:'    電話：852-28937866',
		XGAddressCZ:'  傳真：852-28937177',
		JBAddress:'金邊地址',
		JBAddressXQ:'地址：柬埔寨金邊市堆谷區150街道214號2樓    '
	},
  footer:{
  	shanghaiAddress:'上海總部地址：上海市浦東新區世紀大道1500號東方大廈9樓    ',
  	shanghaiPhone:'    電話：（021）68419699',
  	HongKongAddress:'香港地址：香港九龍尖沙咀廣東道21號海港城港威大廈第五座16樓    ',
  	HongKongPhone:'    電話：（852）28937866',
  	jinbianAddress:'金邊地址：柬埔寨金邊市堆谷區150街道214號2樓    ',
		jinbianPhone:'    電話：（852）28937866',
	  projectCooperation:'項目合作：my@fortune-sun.com',
	  Complaints:'投诉与建议：complain@fortune-sun.com',
  	recruitment:'人才招聘：hr@fortune-sun.com',
  	investorRelations:'投資者關係：info@fortune-sun.com'
  }
}




//////////////////
// WEBPACK FOOTER
// ./static/lang/tc.js
// module id = hFZC
// module chunks = 16